import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Spinner } from 'react-bootstrap';
import InputControl from '../InputControl/InputControl';
import Api from '../../../services/Api';

const PhdAndMastersCitation = ({
  onRequestClose,
  onCitationAdded,
}) => {
  const [author, setAuthor] = useState(undefined);
  const [phd, setPhd] = useState(false);
  const [masters, setMasters] = useState(false);
  const [title, setTitle] = useState(undefined);
  const [edition, setEdition] = useState(undefined);
  const [volume, setVolume] = useState(undefined);
  const [publisher, setPublisher] = useState(undefined);
  const [language, setLanguage] = useState(undefined);
  const [publishDate, setPublishDate] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const save = () => {
    setIsLoading(true);
    Api.post('types/citations', {
      author,
      phd: phd ? 'PhD' : undefined,
      masters: masters ? 'Masters' : undefined,
      title,
      edition,
      volume,
      publisher,
      language,
      resource_type_id: 2,
      date_of_creation: publishDate,
    }).then((response) => {
      setIsLoading(false);
      if (response.status === 201) {
        if (onCitationAdded) {
          onCitationAdded(response.data);
        }
      }
    });
  };
  return (
    <div className="row">
      <div className="col-md-12 mb-2">
        <div className="row">
          <div className="col-md-6 mb-2">
            <label>
              <input
                type="radio"
                name="degree"
                value="Phd"
                checked={phd === true}
                onChange={() => {
                  setPhd(true);
                  setMasters(false);
                  console.log('PhD selected : ', phd);
                }}
              />
              &nbsp;PhD
            </label>
          </div>

          <div className="col-md-6 mb-2">
            <label>
              <input
                type="radio"
                name="degree"
                value="Masters"
                checked={masters === true}
                onChange={() => {
                  setMasters(true);
                  setPhd(false);
                  console.log('masters selected : ', masters);
                }}
              />
              &nbsp;Masters
            </label>
          </div>
        </div>
      </div>
      <div className="col-md-12 mb-2">
        <InputControl type="text" label="Author" placeholder="author..." value={author} onValueChanged={value => setAuthor(value)} />
      </div>
      <div className="col-md-12 mb-2">
        <InputControl type="text" label="Title" placeholder="title..." value={title} onValueChanged={value => setTitle(value)} />
      </div>
      <div className="col-md-12 mb-2">
        <InputControl type="text" label="Edition" placeholder="edition..." value={edition} onValueChanged={value => setEdition(value)} />
      </div>
      <div className="col-md-12 mb-2">
        <InputControl type="text" label="Volume" placeholder="volume..." value={volume} onValueChanged={value => setVolume(value)} />
      </div>
      <div className="col-md-12 mb-2">
        <InputControl type="text" label="Publisher" placeholder="publisher..." value={publisher} onValueChanged={value => setPublisher(value)} />
      </div>
      <div className="col-md-12 mb-2">
        <InputControl type="text" label="Language" placeholder="language..." value={language} onValueChanged={value => setLanguage(value)} />
      </div>
      <div className="col-md-12 mb-2">
        <InputControl type="date" label="Publish Date" placeholder="Publish Date..." value={publishDate} onValueChanged={value => setPublishDate(value)} />
      </div>
      <div className="col-md-12 text-end mt-2">
        <Button variant="warning" onClick={onRequestClose} className="me-3">
          Close
        </Button>
        <Button variant="dark" onClick={save}>
          {isLoading ? (
            <Spinner />
          ) : (
            <span>Save Changes</span>
          )}
        </Button>
      </div>
    </div>
  );
};

PhdAndMastersCitation.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  onCitationAdded: PropTypes.func.isRequired,
};

export default PhdAndMastersCitation;
